import { CopyIconButtonProps } from "./types";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { useClipboard } from "@/hooks";
import { cn } from "@/lib/utils";
import { Copy, Check } from "lucide-react";

export const CopyIconButton = ({ testId = "", size, text }: CopyIconButtonProps) => {
  const { isCopied, handleCopy } = useClipboard();

  const iconSize = size === "large" ? "w-5 h-5" : size === "medium" ? "w-4 h-4" : "w-3.5 h-3.5";

  return (
    <TooltipProvider>
      <Tooltip open={isCopied}>
        <TooltipTrigger asChild>
          <button
            data-testid={testId}
            onClick={() => handleCopy(text)}
            className={cn(
              "rounded-lg p-2 text-cede-text-secondary transition-colors",
              "hover:bg-cede-primary/10 hover:text-cede-primary",
            )}
            aria-label="Copy to clipboard"
          >
            {isCopied ? (
              <Check className={cn(iconSize, "animate-in fade-in-0 zoom-in-50 duration-200")} />
            ) : (
              <Copy className={cn(iconSize, "animate-in fade-in-0 zoom-in-50 duration-200")} />
            )}
          </button>
        </TooltipTrigger>
        <TooltipContent>
          <p>Copied!</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
